// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputCard_inputContainer__mhxjE"};